import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {DateTimePickerModule} from "../../../../../../components/common/datetime-picker/date-time-picker.module";
import {FormFieldModule} from "../../../../../core/component/form-field/form-field.module";
import {SelectModule} from "../../../../../../components/common/select/select.module";
import {SelectElement} from "../../../../../../components/common/select/select.model";
import {WorkflowTaskTriggerType} from "../../../../../workflow/task/api/model/trigger/workflowTaskTrigger.model";
import {MomentAdapter} from "../../../../../../shared/utils/moment.utils";
import {CardModule} from "../../../../../core/component/card/card.module";

@Component({
  selector: 'app-send-email-trigger-form',
  templateUrl: './send-email-trigger-form.component.html',
  standalone: true,
  imports: [
    CommonModule,
    DateTimePickerModule,
    FormFieldModule,
    SelectModule,
    CardModule,
  ]
})
export class SendEmailTriggerFormComponent implements OnChanges{

  triggers: SelectElement[] = [
    new SelectElement(WorkflowTaskTriggerType.WORKFLOW_TASK_TRIGGER_IMMEDIATE, 'Tout de suite'),
    new SelectElement(WorkflowTaskTriggerType.WORKFLOW_TASK_TRIGGER_DATETIME, 'Plus tard')
  ];

  @Input() parentFormGroup: FormGroup;
  @Input() title = 'Options';
  @Input() inCard = true;

  constructor(private formBuilder: FormBuilder) {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.parentFormGroup) {
      this.parentFormGroup.removeControl('typeValue');
      this.parentFormGroup.addControl('typeValue', this.formBuilder.control(WorkflowTaskTriggerType.WORKFLOW_TASK_TRIGGER_IMMEDIATE, Validators.required));
    }
  }

  triggerSelected(triggerValue: string) {
    this.parentFormGroup.removeControl('time');
    if (triggerValue === WorkflowTaskTriggerType.WORKFLOW_TASK_TRIGGER_DATETIME) {
      const control = new FormControl(MomentAdapter.current().addDays(1).setHour(8).setMinute(0).get(), Validators.required);
      const now = MomentAdapter.current().get();
      if (now.hour() < 8) {
        control.setValue(MomentAdapter.current().setHour(8).setMinute(0).get())
      }
      this.parentFormGroup.addControl('time', control);
    }
  }
}
